import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CloverCardJoin = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box
      onClick={() => {
        navigate(
          `user-live-stream/${notification?.data?.id ?? ""}?cardId=${notification?.data?.id ?? ""}`,
        );
      }}
      sx={wrapperStyles(darkMode)}
    >
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <Info sx={{ color: "#6366f1", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title ?? t("notification")}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CloverCardJoin;
